import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import { ProductGroupDetailSection } from "ProductGroup/ProductGroupDetailSection";
import React from "react";
import ProductGroupOptionsPanel from "./ProductGroupOptionsPanel";
import { useLoaderData } from "react-router";

const ProductGroupDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ProductGroupDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <ProductGroupDetailSection
            productGroup={viewModel.productGroup}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <ProductGroupOptionsPanel
            productGroup={viewModel.productGroup}
            listUrl={viewModel.listUrl}
            optionsPanelData={viewModel.optionsPanel}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>;
};

export default ProductGroupDetailApp;